module.exports = __webpack_public_path__ + "static/media/sketches2.4bf6da11.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/sketches2.png
// module id = 188
// module chunks = 0